/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

/**
 * The default locale to use if none specified.
 */
export const defaultLocale = "en-US";

/**
 * The default time-zone to use if none specified.
 */
export const defaultTimezone = "UTC";
